import { createMuiTheme } from 'material-ui/styles';
const white = '#fefefe';
const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      50: '#f5eaf7',
      100: '#e5caec',
      200: '#d4a7df',
      300: '#c383d2',
      400: '#b669c8',
      500: '#a94ebe',
      600: '#a247b8',
      700: '#983daf',
      800: '#8f35a7',
      900: '#7e2599',
      A100: '#f5d8ff',
      A200: '#e9a5ff',
      A400: '#dc72ff',
      A700: '#d658ff',
      'contrastDefaultColor': 'light',
    },
    secondary: {
      50: '#e7e4ee',
      100: '#c4bbd5',
      200: '#9c8eba',
      300: '#74609e',
      400: '#573e89',
      500: '#391c74',
      600: '#33196c',
      700: '#2c1461',
      800: '#241157',
      900: '#170944',
      A100: '#937bff',
      A200: '#6a48ff',
      A400: '#4015ff',
      A700: '#2e00fb',
      'contrastDefaultColor': 'light',
    },
    input: {
      bottomLine: white,
      helperText: white,
      labelText: white,
      inputText: white,
      disabled: white,
      hover: white,
    }
  },
  typography: {
    fontFamily: 'Lato,"Helvetica Neue",Arial,sans-serif',
    color: white,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    headline: {
      fontFamily: 'BlueVinyl-Bold',
      fontSize: '2.5rem',
      color: white
    },
    body1: {
      color: white,
      fontSize: '1.5rem',
    },
    body2: {
      color: white,
      fontSize: '1rem',
    },
    display1: {
      color: white
    },
    display3: {
      fontFamily: 'Varela Round',
      fontSize: '3em',
      color: white
    },
    display4: {
      fontFamily: 'BlueVinyl-Bold',
      color: white
    },
   
  },
  overrides: {
    MuiPaper: {
      root: {
        background: 'rgba(1,1,1,0.3)',
        backgroundColor: null,
      },
    },
    MuiButton: {
      root: {
        color: white,
        '&$disabled': {
          color: 'rgba(255, 255, 255, 0.3)'
        }
      }
    },
  },
})

export default theme;


// WEBPACK FOOTER //
// ./src/lib/theme.js